import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PriceChart = ({ product, hideTitle = false, hideFilter = false, hideX = false, hideY = false }) => {
  const { t } = useTranslation();
  const historicalPrices = product.historicalPrices || [];
  const prices = historicalPrices.slice(Math.max(historicalPrices.length - 30, 1));

  if (!prices?.length) return null;

  const toDecimal = num => (Math.round(num * 100) / 100).toFixed(2);

  const minDate = new Date(prices[0].date).getTime();
  const state = {
    series: [
      {
        name: 'Price',
        data: [
          ...prices.map(p => [
            moment(p.date)
              .utc()
              .valueOf(),
            toDecimal(p.price),
          ]),
        ],
      },
    ],
    options: {
      colors: ['#FF411A'],
      chart: {
        id: 'area-datetime',
        type: 'area',
        height: 185,
        zoom: {
          autoScaleYaxis: true,
        },
        toolbar: {
          show: !hideFilter,
          tools: {
            download: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        labels: {
          show: !hideX,
        },
        type: 'datetime',
        min: minDate,
        tickAmount: 6,
        tooltip: {
          enabled: false,
        },
      },
      yaxis: {
        labels: {
          show: !hideY,
        },
      },
      tooltip: {
        x: {
          format: 'dd MMM yyyy',
        },
      },
      fill: {
        colors: ['#D8D8D8'],
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
    },
  };

  const Chart = require('react-apexcharts').default;

  return (
    <div className='mt-10 mt-md-15 price-chart'>
      <p className='text-body fw-500'>{!hideTitle ? t('price_development') : ''}</p>
      <Chart options={state.options} series={state.series} type='area' height={185} />
    </div>
  );
};

export default PriceChart;
